<div class="pcv" [class.pcv-multi]="multiMode" [class.pcv-listmode]="listMode">
    <!-- decorated toolbar: English month (left) · BIG year (center) ·
         Malayalam era + actions (right) — follows the visible month -->
    <div class="pcv-toolbar">
        <div class="pcv-title">
            <span class="pcv-title-month">{{ visibleBlock?.monthName || 'Panchang' }}</span>
            <span class="pcv-subtitle">{{ visibleBlock?.mlLabel || visibleMlLabel }}</span>
        </div>
        <div class="pcv-title-year">{{ visibleBlock?.year }}</div>
        <div class="pcv-actions">
            <button type="button" class="pcv-btn pcv-btn-today" *ngIf="showTodayButton"
                (click)="goToCurrentMonth()" title="Back to the current month">
                <i class="fa fa-calendar-o"></i><span class="pcv-btn-text">Current month</span>
            </button>
            <button type="button" class="pcv-btn pcv-btn-filter" *ngIf="!hideMultipleDate" [class.pcv-active]="filterOpen"
                (click)="toggleFilterPanel()" title="Filter days (star / thithi / weekday / month)">
                <i class="fa fa-filter"></i><span class="pcv-btn-text">Filter</span>
            </button>
            <button type="button" class="pcv-btn pcv-btn-multi" *ngIf="!hideMultipleDate" [class.pcv-active]="multiMode"
                (click)="toggleMultipleDate()">
                <i class="fa" [ngClass]="multiMode ? 'fa-calendar' : 'fa-plus'"></i>
                <span class="pcv-btn-text">{{ multiMode ? 'Single Date' : 'Multiple Date' }}</span>
            </button>
            <button type="button" class="pcv-close" (click)="cancel()" aria-label="Close">&#10005;</button>
        </div>
    </div>

    <!-- in-panel continuous-booking filter: the month-period picker FIRST
         (defaults to 1 year from the current month), then the dimension
         dropdowns — mobile picks ONE dimension at a time; desktop shows every
         dropdown (AND, like the legacy modal) -->
    <div class="pcv-filterbar" *ngIf="filterOpen">
        <!-- [static]: the popup renders INLINE under the input, inside the
             modal — the body-appended fixed popup never showed up in the live
             AppModal (the same failure class app-lookup hit; static is the
             proven in-modal pattern, cf. the continuous modal's pickers) -->
        <app-date-picker class="pcv-filter-range" selectionMode="period" minMode="month" [small]="true"
            [static]="true" placeholder="mmm yyyy to mmm yyyy" [rangeStart]="filterRangeStartDj"
            [rangeEnd]="filterRangeEndDj" (dateSelect)="onFilterRangeChange($event)"></app-date-picker>
        <ng-container *ngIf="isMobile; else desktopFilters">
            <select class="pcv-filter-select" [ngModel]="filterDimension"
                (ngModelChange)="onFilterDimensionChange($event)" aria-label="Filter by">
                <option value="">Filter by&#8230;</option>
                <option value="star">Star</option>
                <option value="thithi">Thithi</option>
                <option value="week">Week day</option>
                <option value="month">EN month</option>
                <option value="mlMonth">Ml month</option>
            </select>
            <select class="pcv-filter-select" *ngIf="filterDimension === 'star'" [ngModel]="filters.star"
                (ngModelChange)="onFilterValueChange('star', $event)" aria-label="Star">
                <option value="">All stars</option>
                <option *ngFor="let o of starOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <select class="pcv-filter-select" *ngIf="filterDimension === 'thithi'" [ngModel]="filters.thithi"
                (ngModelChange)="onFilterValueChange('thithi', $event)" aria-label="Thithi">
                <option value="">All thithis</option>
                <option *ngFor="let o of thithiOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <!-- the same grouped Week dropdown as desktop (round 13): the
                 native mobile picker renders the optgroups as sections -->
            <select class="pcv-filter-select" *ngIf="filterDimension === 'week'" [ngModel]="weekComboValue"
                (ngModelChange)="onWeekComboChange($event)" aria-label="Week day">
                <option value="">All days</option>
                <optgroup *ngFor="let g of weekComboGroups" [label]="g.label">
                    <option *ngFor="let o of g.options" [value]="o.value">{{ o.label }}</option>
                </optgroup>
            </select>
            <select class="pcv-filter-select" *ngIf="filterDimension === 'month'" [ngModel]="filters.month"
                (ngModelChange)="onFilterValueChange('month', $event)" aria-label="Month">
                <option value="">All EN months</option>
                <option *ngFor="let o of monthOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <select class="pcv-filter-select" *ngIf="filterDimension === 'mlMonth'" [ngModel]="filters.mlMonth"
                (ngModelChange)="onFilterValueChange('mlMonth', $event)" aria-label="Malayalam month">
                <option value="">All Ml months</option>
                <option *ngFor="let o of mlMonthOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <!-- Pradosham composes with (or replaces) the picked dimension,
                 like on desktop (owner round 14) -->
            <label class="pcv-filter-check">
                <input type="checkbox" [checked]="filters.pradosham"
                    (change)="onPradoshamChange($any($event.target).checked)">
                <span>Pradosham</span>
            </label>
        </ng-container>
        <ng-template #desktopFilters>
            <select class="pcv-filter-select" [ngModel]="filters.star"
                (ngModelChange)="onFilterValueChange('star', $event)" aria-label="Star">
                <option value="">Star&#8230;</option>
                <option *ngFor="let o of starOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <select class="pcv-filter-select" [ngModel]="filters.thithi"
                (ngModelChange)="onFilterValueChange('thithi', $event)" aria-label="Thithi">
                <option value="">Thithi&#8230;</option>
                <option *ngFor="let o of thithiOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <!-- ONE Week dropdown (round 13 data, R27b interaction): the
                 owner's cascade-select — weekday rows whose submenu holds the
                 day-itself + m:/e: 1st..Last occurrence rows; same
                 weekComboValue/onWeekComboChange contract as the old optgroup
                 select (mobile keeps the native optgroup picker below) -->
            <app-cascade-select class="pcv-week-cascade" [groups]="weekComboGroups"
                [value]="weekComboValue" placeholder="Week day&#8230;" clearLabel="All days"
                ariaLabel="Week day" (valueChange)="onWeekComboChange($event)"></app-cascade-select>
            <select class="pcv-filter-select" [ngModel]="filters.month"
                (ngModelChange)="onFilterValueChange('month', $event)" aria-label="Month">
                <option value="">EN month&#8230;</option>
                <option *ngFor="let o of monthOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <select class="pcv-filter-select" [ngModel]="filters.mlMonth"
                (ngModelChange)="onFilterValueChange('mlMonth', $event)" aria-label="Malayalam month">
                <option value="">Ml month&#8230;</option>
                <option *ngFor="let o of mlMonthOptions" [value]="o.value">{{ o.label }}</option>
            </select>
            <!-- Pradosham-days filter (owner round 14) — same source of truth
                 as the legacy Continuous Booking modal's checkbox -->
            <label class="pcv-filter-check">
                <input type="checkbox" [checked]="filters.pradosham"
                    (change)="onPradoshamChange($any($event.target).checked)">
                <span>Pradosham</span>
            </label>
            <!-- back in the bar (owner round 13, gold pill round 14):
                 available-day count / custom from-to still live in the modal -->
            <button type="button" class="pcv-btn pcv-btn-advanced" (click)="onMultipleDateClick()"
                title="Advanced continuous booking (day count, custom range)">
                <i class="fa fa-sliders"></i><span>Advanced</span></button>
        </ng-template>
        <button type="button" class="pcv-filter-clear" *ngIf="filtersActive" (click)="clearFilters()"
            title="Clear filters">&#10005;</button>
    </div>

    <!-- weekday strip (grid layout only — list rows carry their own weekday) -->
    <div class="pcv-weekdays" *ngIf="!listMode">
        <span class="pcv-weekday" *ngFor="let weekday of weekDays; let i = index" [class.pcv-sunday]="i === 0">
            <span class="pcv-wd-short">{{ weekday.en }}</span>
            <span class="pcv-wd-full">{{ lang === 'malayalam' ? weekday.ml : weekday.enFull }}</span>
        </span>
    </div>

    <!-- the scrolling month list; each month header is sticky -->
    <div class="pcv-scroll" #scrollHost>
        <button type="button" class="pcv-load-earlier" *ngIf="canLoadEarlier && !earlierUnlocked" (click)="loadEarlier()">
            <i class="fa fa-angle-up"></i>&nbsp;Earlier months
        </button>

        <ng-container *ngFor="let m of monthBlocks; trackBy: trackByMonth">
        <section class="pcv-month" *ngIf="!filtersActive || visibleDays(m).length"
            [attr.data-key]="m.key" [attr.data-ml]="m.mlLabel">
            <!-- sticky header: year + month are clickable chips that open
                 app-date-picker-style jump grids (navigate straight to e.g.
                 2030 March); policy-disabled years/months are excluded -->
            <header class="pcv-month-head">
                <span class="pcv-month-title">
                    <span class="pcv-head-chip" title="Jump to year"
                        (click)="openHeadEdit(m, 'year', $event)">{{ m.year }}<i class="fa fa-caret-down"></i></span>
                    <span class="pcv-head-chip" title="Jump to month"
                        (click)="openHeadEdit(m, 'month', $event)">{{ m.monthName }}<i class="fa fa-caret-down"></i></span>
                </span>
                <span class="pcv-month-ml">{{ m.mlLabel }}</span>
            </header>

            <!-- desktop month grid -->
            <div class="pcv-grid" *ngIf="!listMode">
                <ng-container *ngFor="let week of m.weeks">
                    <div class="pcv-cell" *ngFor="let day of week"
                        [class.pcv-empty]="!day?.date"
                        [class.pcv-clickable]="!!day?.date && !day?.blocked && (day?.isPartial !== false || day?.overbookable)"
                        [class.pcv-partial]="day?.isPartial === true"
                        [class.pcv-full]="day?.isPartial === false"
                        [class.pcv-blocked]="!!day?.blocked"
                        [class.pcv-selected]="multiMode ? !!day?.isMultiSelected : (!!day?.isSelected && !day?.isPartial && !day?.isToday)"
                        [class.pcv-today]="!!day?.isToday"
                        [class.pcv-sunday]="day?.day === 0"
                        (click)="onDayClick(day)"
                        (mouseenter)="showTip(day, $event)" (mouseleave)="hideTip()">
                        <ng-container *ngIf="!!day?.date">
                            <span class="pcv-check" *ngIf="multiMode && !day?.blocked && day?.isPartial !== false"
                                [class.pcv-checked]="!!day?.isMultiSelected"></span>
                            <div class="pcv-cell-top">
                                <span class="pcv-moon pcv-moon-new" *ngIf="day.moon === 'new'" title="Amavasi"></span>
                                <span class="pcv-moon pcv-moon-full" *ngIf="day.moon === 'full'" title="Pournami"></span>
                                <span class="pcv-ml-day">{{ day.mlDetails?.mlDate }}</span>
                            </div>
                            <span class="pcv-day-num">{{ day.date }}</span>
                            <div class="pcv-lines">
                            <div class="pcv-line pcv-star">
                                <span class="pcv-name">{{ day.mlDetails?.starName }}</span>
                                <span class="pcv-time">{{ day.mlDetails?.naksatra?.isTimeHide ? '' : day.mlDetails?.naksatra?.startAndend }}</span>
                            </div>
                            <div class="pcv-line pcv-star" *ngIf="day.mlDetails?.secondStar">
                                <span class="pcv-name">{{ day.mlDetails?.secondstarName }}</span>
                                <span class="pcv-time">{{ day.mlDetails?.secondStar?.isTimeHide ? '' : day.mlDetails?.secondStar?.startAndend }}</span>
                            </div>
                            <div class="pcv-line pcv-tithi">
                                <span class="pcv-name">{{ day.mlDetails?.tithiName }}</span>
                                <span class="pcv-time">{{ day.mlDetails?.tithi?.isTimeHide ? '' : day.mlDetails?.tithi?.startAndend }}</span>
                            </div>
                            <div class="pcv-line pcv-tithi" *ngIf="day.mlDetails?.secondTithi">
                                <span class="pcv-name">{{ day.mlDetails?.secondTithiName }}</span>
                                <span class="pcv-time">{{ day.mlDetails?.secondTithi?.isTimeHide ? '' : day.mlDetails?.secondTithi?.startAndend }}</span>
                            </div>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>

            <!-- mobile / filtered list: one full-width row per day (weekday,
                 star/tithi with end hours, moon, small ml day top-right) -->
            <div class="pcv-list" *ngIf="listMode">
                <div class="pcv-row" *ngFor="let day of visibleDays(m)"
                    [attr.data-day]="dayKeyOf(day)"
                    [class.pcv-clickable]="!day?.blocked && (day?.isPartial !== false || day?.overbookable)"
                    [class.pcv-partial]="day?.isPartial === true"
                    [class.pcv-full]="day?.isPartial === false"
                    [class.pcv-blocked]="!!day?.blocked"
                    [class.pcv-selected]="multiMode ? !!day?.isMultiSelected : (!!day?.isSelected && !day?.isPartial && !day?.isToday)"
                    [class.pcv-today]="!!day?.isToday"
                    [class.pcv-sunday]="day?.day === 0"
                    (click)="onDayClick(day)"
                    (mouseenter)="showTip(day, $event)" (mouseleave)="hideTip()">
                    <div class="pcv-row-left">
                        <span class="pcv-row-num">{{ day.date }}</span>
                        <span class="pcv-row-wd">{{ lang === 'malayalam' ? weekDays[day.day]?.ml : weekDays[day.day]?.enFull }}</span>
                    </div>
                    <div class="pcv-row-mid">
                        <div class="pcv-line pcv-star">
                            <span class="pcv-name">{{ day.mlDetails?.starName }}</span>
                            <span class="pcv-time">{{ day.mlDetails?.naksatra?.isTimeHide ? '' : day.mlDetails?.naksatra?.startAndend }}</span>
                        </div>
                        <div class="pcv-line pcv-star" *ngIf="day.mlDetails?.secondStar">
                            <span class="pcv-name">{{ day.mlDetails?.secondstarName }}</span>
                            <span class="pcv-time">{{ day.mlDetails?.secondStar?.isTimeHide ? '' : day.mlDetails?.secondStar?.startAndend }}</span>
                        </div>
                        <div class="pcv-line pcv-tithi">
                            <span class="pcv-name">{{ day.mlDetails?.tithiName }}</span>
                            <span class="pcv-time">{{ day.mlDetails?.tithi?.isTimeHide ? '' : day.mlDetails?.tithi?.startAndend }}</span>
                        </div>
                        <div class="pcv-line pcv-tithi" *ngIf="day.mlDetails?.secondTithi">
                            <span class="pcv-name">{{ day.mlDetails?.secondTithiName }}</span>
                            <span class="pcv-time">{{ day.mlDetails?.secondTithi?.isTimeHide ? '' : day.mlDetails?.secondTithi?.startAndend }}</span>
                        </div>
                    </div>
                    <div class="pcv-row-right">
                        <span class="pcv-ml-day">{{ day.mlDetails?.mlDate }}</span>
                        <span class="pcv-moon pcv-moon-new" *ngIf="day.moon === 'new'" title="Amavasi"></span>
                        <span class="pcv-moon pcv-moon-full" *ngIf="day.moon === 'full'" title="Pournami"></span>
                        <span class="pcv-check pcv-row-check" *ngIf="multiMode && !day?.blocked && day?.isPartial !== false"
                            [class.pcv-checked]="!!day?.isMultiSelected"></span>
                    </div>
                </div>
            </div>
        </section>
        </ng-container>

        <div class="pcv-loading" *ngIf="appending">Loading&#8230;</div>
    </div>

    <!-- booked-devotee / holiday details: ONE floating tooltip anchored right
         beside the hovered cell, its arrow touching the cell edge -->
    <div class="pcv-float-tip" *ngIf="tip" [style.left.px]="tip.x" [style.top.px]="tip.y"
        [class.pcv-tip-on-left]="tip.side === 'left'">
        <span class="pcv-tip-arrow" [style.top.px]="tip.arrowY"></span>
        <div class="pcv-tip-title">{{ tip.title }}</div>
        <div class="pcv-tip-body" [innerHTML]="tip.content"></div>
    </div>

    <!-- year/month jump panels: absolutely positioned at the clicked chip in
         HOST coordinates (the transformed modal pane re-bases fixed
         positioning); any scroll closes them -->
    <ng-container *ngIf="headEditBlock as jm">
        <div class="pcv-jump-panel" *ngIf="isHeadEdit(jm, 'year')" (click)="$event.stopPropagation()"
            [style.left.px]="headEdit.x" [style.top.px]="headEdit.y">
            <div class="pcv-jump-nav">
                <button type="button" class="pcv-jump-arrow" [disabled]="!canYearPagePrev"
                    (click)="yearPagePrev()">&#8249;</button>
                <span class="pcv-jump-range">{{ yearPage }} - {{ yearPageEnd }}</span>
                <button type="button" class="pcv-jump-arrow" [disabled]="!canYearPageNext"
                    (click)="yearPageNext()">&#8250;</button>
            </div>
            <div class="pcv-jump-grid">
                <button type="button" class="pcv-jump-opt" *ngFor="let y of yearPageOptions"
                    [class.pcv-jump-active]="y === jm.year" (click)="onHeadYearChange(jm, y)">{{ y }}</button>
            </div>
        </div>
        <div class="pcv-jump-panel" *ngIf="isHeadEdit(jm, 'month')" (click)="$event.stopPropagation()"
            [style.left.px]="headEdit.x" [style.top.px]="headEdit.y">
            <div class="pcv-jump-grid">
                <button type="button" class="pcv-jump-opt" *ngFor="let mo of months; let i = index"
                    [class.pcv-jump-active]="i === jm.month" [disabled]="isMonthDisabled(jm.year, i)"
                    (click)="onHeadMonthChange(jm, i)">{{ mo.en | slice:0:3 }}</button>
            </div>
        </div>
    </ng-container>

    <!-- multi-select footer BELOW the scroller (never over the last row).
         Filter view: ONE toggle button — Unselect all ⇄ Select all (the days a
         chosen filter matches are selected by default). Plain Multiple Date:
         Unselect all appears once several days are ticked and hides again. -->
    <div class="pcv-footer" *ngIf="multiMode">
        <button type="button" class="pcv-btn pcv-unselect" *ngIf="filtersActive" (click)="toggleSelectAll()">
            <i class="fa" [ngClass]="multiCount ? 'fa-square-o' : 'fa-check-square-o'"></i>&nbsp;{{ multiCount ? 'Unselect all' : 'Select all' }}
        </button>
        <button type="button" class="pcv-btn pcv-unselect" *ngIf="!filtersActive && multiCount > 1" (click)="unselectAll()">
            <i class="fa fa-square-o"></i>&nbsp;Unselect all
        </button>
        <button type="button" class="pcv-submit" [disabled]="!multiCount" (click)="submitMultiDates()">
            Submit<ng-container *ngIf="multiCount"> ({{ multiCount }} {{ multiCount === 1 ? 'day' : 'days' }})</ng-container>
        </button>
    </div>
</div>
